import { Footer, Header } from "@/views";
import { Layout } from "antd";
import type { ElementType } from "react";

const HomeLayout: ElementType = ({ children }) => {
  return (
    <Layout>
      <Layout.Header
        style={{
          position: "fixed",
          width: "100dvw",
          height: "4em",
          padding: "0.7em 0 0.5em 5%",
          backgroundColor: "white"
        }}
      >
        <Header />
      </Layout.Header>
      <Layout.Content
        style={{
          width: "100dvw",
          minHeight: "80dvh",
          margin: "4em 0 2em 0"
        }}
      >
        {children}
      </Layout.Content>
      <Layout.Footer
        style={{
          position: "fixed",
          bottom: "0",
          width: "100dvw",
          padding: "0"
        }}
      >
        <Footer />
      </Layout.Footer>
    </Layout>
  );
};

export default HomeLayout;
